import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import UdcTabbedSelect from '@/components/common/UdcTabbedSelect.vue'
import { useInitDataStore } from '@/stores/initDataStore'

export type IndexTypes = {
  tabIndex: number
  listItemIndex: number
  itemIndex: number
}

export type SelectorProps = {
  defaults?: IndexTypes
}


export default /*#__PURE__*/_defineComponent({
  props: {
    defaults: null
  },
  emits: ['select'],
  setup(__props: any, { emit }) {




const initDataStore = useInitDataStore()

const definitionInfo = computed(() => {
  return initDataStore.initData.definitionInfo?.reports.common.listItems
})

const tabs = computed(() => {
  return definitionInfo.value.items
})

const select = ({ tabIndex, listItemIndex, itemIndex }: IndexTypes) => {
  const item = tabs.value[tabIndex].items[listItemIndex].items[itemIndex]

  emit('select', item)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UdcTabbedSelect, {
    onSelect: select,
    title: _unref(definitionInfo).title,
    tabs: _unref(tabs),
    defaults: __props.defaults
  }, null, 8, ["title", "tabs", "defaults"]))
}
}

})